export enum WhatsAppAccountStatus {
  Approved = 'approved',
  Rejected = 'rejected',
  Pending = 'pending',
  Unavailable = 'unavailable',
  Restricted = 'restricted',
}

export enum WhatsAppBusinessPhoneStatus {
  Available = 'available',
  Unavailable = 'unavailable',
  NameRejected = 'nameRejected',
  Pending = 'pending',
}

export enum WhatsAppBusinessPhoneRating {
  Unknown = 'UNKNOWN',
  High = 'GREEN',
  Medium = 'YELLOW',
  Low = 'RED',
}

export enum WhatsAppBusinessPhoneLimit {
  TIER_50 = 'TIER_50',
  TIER_250 = 'TIER_250',
  TIER_1K = 'TIER_1K',
  TIER_10K = 'TIER_10K',
  TIER_100K = 'TIER_100K',
  TIER_UNLIMITED = 'TIER_UNLIMITED',
}

export type WhatsAppAccountCreateParams = {
  accountId: string
  phoneId: string
  code: string
  pin: string
}

export enum WhatsappBusinessRestrictionType {
  CustomerInitiatedMessaging = 'RESTRICTED_CUSTOMER_INITIATED_MESSAGING',
  BizInitiatedMessaging = 'RESTRICTED_BIZ_INITIATED_MESSAGING',
  AddPhoneNumberAction = 'RESTRICTION_ON_ADD_PHONE_NUMBER_ACTION',
}

export type WhatsappBusinessRestriction = {
  type: WhatsappBusinessRestrictionType
  expiredAt: string
}
